import request from '@/utils/request'
import onlyNasFileUploadUseRequest from '@/utils/onlyNasFileUploadUseRequest'

export function getAccentList (tuid) { //获取句子
  return request({
    url: '/api/TutorAccentEvaluate/GetAccentEvaluateSentenceList?tuid=' + tuid,
    method: 'Post'
  })
}

export function uploadAccentSentence (tuid, sentenceId, formData) { //上传录音
    return onlyNasFileUploadUseRequest({
      timeout: 10 * 60 * 1000,
      url: `/api/TutorAccentEvaluate/UploadSentence?tuid=${tuid}&sentenceId=${sentenceId}`,
      method: 'Post',
      data: formData
    })
}

export function getTotalScore (tuid) {  //获取分数
    return request({
      url: `/api/TutorAccentEvaluate/EvaluateAccent?tuid=${tuid}`,
      method: 'Post'
    })
}